import { render, staticRenderFns } from "./ExcTickerLogosBlock.vue?vue&type=template&id=0f7b1aa0&scoped=true&"
import script from "./ExcTickerLogosBlock.vue?vue&type=script&lang=js&"
export * from "./ExcTickerLogosBlock.vue?vue&type=script&lang=js&"
import style0 from "./ExcTickerLogosBlock.vue?vue&type=style&index=0&id=0f7b1aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7b1aa0",
  null
  
)

export default component.exports